export const mastheadMeta = {
  brand: "44黑料区",
  volume: "VOL.44",
  issue: "第 44 期 · 深夜号",
  date: "2026 年 9 月 12 日",
  weekday: "星期六",
  tagline: "24 小时不间断 · 第一时间推送今日新鲜黑料与实时爆料",
  ticker: [
    "03:12 某男团主舞连夜搬离宿舍，合约进入协商阶段",
    "02:48 一段 47 秒后台录音在网络流传，双方暂未回应",
    "01:35 两个代言海报同日下架，品牌方称「正常换季」",
    "00:57 直播连麦口误冲上热搜，当事人已关闭评论区",
    "23:40 某剧组临时换角，官方通告仅 68 字",
  ],
};

export const heroStory = {
  kicker: "本期封面",
  title: "凌晨三点的速递：这一周的娱乐圈，谁都没能睡好",
  dek: "从合约风波到后台录音，我们把过去 24 小时里被反复转发的 9 条线索，按时间轴重新拼了一遍，也标出了每一条目前仍然存疑的部分。",
  meta: ["更新 02:41", "阅读 8.6 万", "评论 1,204", "线索 9 条"],
  tags: ["今日黑料", "实时爆料"],
  primaryCta: "阅读本期封面",
  secondaryCta: "查看今日速递",
  image:
    "https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20still%20life%20on%20warm%20cream%20paper%20backdrop%2C%20folded%20newspaper%20and%20a%20vintage%20handheld%20tape%20recorder%20resting%20on%20a%20marble%20table%2C%20single%20soft%20side%20light%20from%20the%20left%2C%20deep%20gentle%20shadows%2C%20muted%20terracotta%20and%20aged%20gold%20tones%2C%20visible%20film%20grain%2C%20cinematic%20magazine%20aesthetic%2C%20calm%20empty%20negative%20space%20around%20the%20subject%2C%20high%20detail&width=900&height=1200&seq=hl-hero-cover-44&orientation=portrait",
  coverLines: [
    { no: "01", text: "合约风波：一份没签完的补充协议" },
    { no: "02", text: "后台录音：47 秒里出现的三个名字" },
    { no: "03", text: "直播失言：热搜停留了 6 小时 12 分" },
  ],
};

export const todayFeed = [
  {
    time: "03:12",
    channel: "合约风波",
    title: "某男团主舞被曝连夜搬离宿舍，团队行程临时调整",
    note: "经纪公司尚未发布正式说明，成员个人账号保持沉默。",
    heat: "爆",
  },
  {
    time: "02:48",
    channel: "后台录音",
    title: "一段 47 秒录音在多个平台流传，转发量半小时破万",
    note: "录音来源与完整性均无法核实，请谨慎对待。",
    heat: "热",
  },
  {
    time: "01:35",
    channel: "品牌动态",
    title: "两家品牌代言海报同日下架，官方回应称正常季度更换",
    note: "其中一家保留了官网图文，动作并不一致。",
    heat: "新",
  },
  {
    time: "00:57",
    channel: "直播现场",
    title: "直播连麦时口误引发讨论，当事人随后关闭评论区",
    note: "回放片段已被剪辑成十余个版本。",
    heat: "热",
  },
  {
    time: "23:40",
    channel: "剧集动态",
    title: "某古装剧组临时换角，官方通告全文仅 68 个字",
    note: "接替人选未公布，剧组已连续两天夜戏。",
    heat: "新",
  },
  {
    time: "22:16",
    channel: "粉丝视角",
    title: "后援会集体停更三天，声明中出现了「等待答复」四个字",
    note: "相关话题阅读量仍在缓慢上涨。",
    heat: "",
  },
];

export const bigCards = [
  {
    id: "feature-1",
    label: "深夜特稿",
    title: "一档选秀节目的十年，和一地没扫干净的名利场",
    excerpt:
      "从初舞台到成团夜，我们找到七位不同届的选手，聊了聊合同里那些当年没看懂的条款，以及散场之后各自的去向。",
    author: "编辑部 · 陈屿",
    readTime: "11 分钟",
    views: "4.2 万",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20after%20a%20show%2C%20warm%20amber%20stage%20lights%20still%20on%2C%20scattered%20chairs%20and%20cables%2C%20muted%20terracotta%20and%20dusty%20gold%20palette%2C%20soft%20haze%20in%20the%20air%2C%20film%20photography%20texture%2C%20melancholic%20editorial%20mood%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1000&height=700&seq=hl-feature-01&orientation=landscape",
  },
  {
    id: "feature-2",
    label: "幕后纪实",
    title: "经纪公司凌晨三点的会议室里，到底在谈什么",
    excerpt:
      "一张被反复转发的排期表，牵出了一条完整的资源分配逻辑。我们试着把它还原成一张所有人都能看懂的图。",
    author: "编辑部 · 苏晓",
    readTime: "9 分钟",
    views: "3.7 万",
    image:
      "https://readdy.ai/api/search-image?query=Late%20night%20meeting%20room%20in%20an%20entertainment%20agency%2C%20long%20empty%20table%20with%20scattered%20schedule%20papers%2C%20single%20warm%20desk%20lamp%20glow%2C%20muted%20brown%20and%20cream%20tones%2C%20soft%20film%20grain%2C%20quiet%20tense%20editorial%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1000&height=700&seq=hl-feature-02&orientation=landscape",
  },
  {
    id: "feature-3",
    label: "现场回放",
    title: "那场直播事故的 12 分钟，逐帧拆给你看",
    excerpt:
      "从画面卡顿到弹幕失控，我们把关键节点截成 12 张图，标注出每一次情绪转折发生在第几秒。",
    author: "编辑部 · 阿卓",
    readTime: "7 分钟",
    views: "5.1 万",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20live%20streaming%20studio%20desk%20at%20night%2C%20ring%20light%20switched%20off%2C%20monitors%20showing%20soft%20static%20glow%2C%20muted%20terracotta%20and%20warm%20grey%20palette%2C%20film%20photography%20texture%2C%20dramatic%20but%20restrained%20lighting%2C%20cinematic%20composition%2C%20high%20detail&width=1000&height=700&seq=hl-feature-03&orientation=landscape",
  },
];

export const collectionIndex = [
  {
    no: "01",
    title: "年度塌房档案",
    count: "44 期",
    desc: "按时间顺序整理全年被反复讨论的事件节点。",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20aged%20archive%20folders%20on%20a%20cream%20paper%20surface%2C%20warm%20muted%20terracotta%20labels%2C%20soft%20directional%20light%2C%20film%20grain%20texture%2C%20minimal%20editorial%20still%20life%2C%20high%20detail&width=600&height=600&seq=hl-index-01&orientation=squarish",
  },
  {
    no: "02",
    title: "未解之谜合辑",
    count: "27 条",
    desc: "只有片段、没有结论的线索，被单独归到一处。",
    image:
      "https://readdy.ai/api/search-image?query=Magnifying%20glass%20resting%20on%20blank%20cream%20paper%20with%20faint%20question%20marks%2C%20warm%20muted%20tones%2C%20soft%20side%20lighting%2C%20film%20grain%2C%20minimal%20editorial%20still%20life%2C%20high%20detail&width=600&height=600&seq=hl-index-02&orientation=squarish",
  },
  {
    no: "03",
    title: "录音门事件簿",
    count: "19 段",
    desc: "每一段音频的时长、来源与存疑点都做了标注。",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20handheld%20tape%20recorder%20on%20warm%20cream%20backdrop%2C%20single%20soft%20light%2C%20muted%20terracotta%20and%20gold%20accents%2C%20film%20grain%20texture%2C%20minimal%20editorial%20still%20life%2C%20high%20detail&width=600&height=600&seq=hl-index-03&orientation=squarish",
  },
  {
    no: "04",
    title: "直播事故集",
    count: "33 起",
    desc: "从口误到断线，按事故类型重新分成了五类。",
    image:
      "https://readdy.ai/api/search-image?query=Small%20studio%20microphone%20on%20a%20table%20beside%20a%20switched%20off%20on%20air%20sign%2C%20warm%20muted%20terracotta%20palette%2C%20soft%20light%2C%20film%20grain%20texture%2C%20minimal%20editorial%20still%20life%2C%20high%20detail&width=600&height=600&seq=hl-index-04&orientation=squarish",
  },
];

export const liveFeed = [
  { time: "刚刚", text: "有网友称在机场偶遇当事人，暂无图片佐证。" },
  { time: "6 分钟前", text: "相关话题在榜单上的位置由第 4 位升至第 2 位。" },
  { time: "18 分钟前", text: "一段新的聊天记录截图流出，时间戳存在明显矛盾。" },
  { time: "35 分钟前", text: "某位前同事发文，全文只有一句「先不评价」。" },
  { time: "1 小时前", text: "官方粉丝团发布公告，暂停本周全部应援安排。" },
  { time: "2 小时前", text: "两家媒体先后撤下同一篇稿件，原因未公开。" },
];

export const topics = [
  "今日黑料",
  "实时爆料",
  "新料速递",
  "塌房现场",
  "录音门",
  "直播事故",
  "合约纠纷",
  "后台花絮",
  "热搜档案",
  "粉丝视角",
];

export const subscribeBlock = {
  eyebrow: "44 速递",
  title: "把最新动态，直接送到你手边",
  desc: "订阅「44速递」，每条新料第一时间送达。我们只推送真正被反复讨论的线索，不做无意义的刷新。",
  bullets: ["每日 2 封，早晚各一次", "只推核心线索，不堆量", "随时可退订，不做二次打扰"],
};